jQuery(function() {
    jQuery(document).on('click', '.lang-switcher', function(e) {
        e.preventDefault();
        let languageId = parseInt($(this).data('lang'));
        switchLanguage(languageId);
    });

    jQuery(document).on('click', '.table-search-submit', searchTable);

    jQuery(document).on('keypress', '.table-search-container :input', function(e) {
        if (e.which === 13) { // enter
            $(this).closest('.table-search-container').find('.table-search-submit').trigger('click');
        }
    });

    jQuery(document).on('click', '.confirm-action', confirmAction);

    // jQuery('.datepicker').datetimepicker({
    //     timepicker: false,
    //     format: 'Y-m-d'
    // });

    function switchLanguage(languageId) {
        let selector = '.lang-' + languageId;
        jQuery('.lang-container').not(selector).addClass('d-none');
        jQuery(selector).removeClass('d-none');
    }

    /** ------------------------------------------------------------------------------------------------------------ **/

    function searchTable(e) {
        e.preventDefault();

        let $button = jQuery(this);
        let searchLink = $button.attr('href');

        let $fields = $(':input', $button.closest('.table-search-container'));
        searchLink += ((searchLink.indexOf('?') === -1) ? '?' : '&') + $fields.serialize();

        location.assign(searchLink);
    }

    /** ------------------------------------------------------------------------------------------------------------ **/

    function confirmAction() {
        let message = $('#js-messages').data('confirmation');
        return confirm(message);
    }

    /** ------------------------------------------------------------------------------------------------------------ **/

    (function() {
        let $form = jQuery('.client-payments');

        $form.on('input', '.address-field', function() {
            let $field = $(this);
            let $selector = $field.closest('.address-card').find('.address-selector');
            let $saveHandler = $field.closest('.address-card').find('.address-save-field');

            $selector.val('');
            $saveHandler.removeAttr('disabled');
        });

        $form.on('change', '.lang-selector', function() {
            jQuery('#destination_address_id').trigger('change');
        });

        $form.on('change', '#destination_address_id', function() {
            let $select = jQuery(this);
            let $option = $select.find(':selected');
            let $saveHandler = $select.closest('.address-card').find('.address-save-field');
            let $wrapper = $select.closest('.addresses-wrapper');

            let languageIso = getLanguageIso();
            let data;
            let $container;
            let route;

            if (!$option.val()) {
                $saveHandler.removeAttr('disabled');
                $container = $('.origin-address-card-wrapper');
                route = $wrapper.attr('data-origin-address-route');
                data = {language_iso: languageIso};
            } else {
                $container = $wrapper;
                route = $wrapper.attr('data-addresses-route');
                let address = $option.val();
                data = {language_iso: languageIso, address_id: address};
            }

            window.axios.post(route, data)
                .then(res => {
                    if (res && res.data && parseInt(res.data.result) === 1) {
                        $container.replaceWith(res.data.html);
                    }
                }).catch(err => {
                console.log(err);
            });
        });

        function getLanguageIso() {
            return jQuery('.lang-selector').val();
        }
    }());

    /** ------------------------------------------------------------------------------------------------------------ **/

    (function() {
        function getLanguageIso() {
            return jQuery('.languages-switcher').val();
        }

        function getCustomerId() {
            return parseInt(jQuery('.clients-switcher').val());
        }

        function getMerchantId() {
            return parseInt(jQuery('.merchant-switcher').val());
        }

        let $form = jQuery('.admin-payments')

        $form.on('input', '.address-field', function() {
            let $field = $(this);
            let $selector = $field.closest('.address-card').find('.address-selector');
            let $saveSwitcher = $field.closest('.address-card').find('.address-save-field');

            $selector.val('');
            $saveSwitcher.removeAttr('disabled');
        });

        $form.on('change', '.clients-switcher', function() {
            let clientId = getCustomerId();
            let $container= jQuery('.addresses-wrapper');

            if (!clientId) {
                $container.html('');
            } else {
                let route = $('.addresses-wrapper').attr('data-addresses-route');
                let languageIso = getLanguageIso();
                let data = {language_iso: languageIso, client_id: clientId}
                sendAjaxRequest($container, route, data);
            }
        });

        $form.on('change', '#destination_address_id', function() {
            let $select = jQuery(this);
            let $option = $select.find(':selected');
            let $container = $select.closest('.destination-address-card-wrapper');
            let $wrapper = jQuery('.addresses-wrapper');

            let languageIso = getLanguageIso();
            // let clientId = getCustomerId();
            let merchantId = getMerchantId();
            let addressId = $option.val();

            if (addressId) {
                let data = {language_iso: languageIso, merchant_id: merchantId,  address_id: addressId};
                let route = $wrapper.attr('data-destination-address-route');
                sendAjaxRequest($container, route, data);
            } else {
                let $saveSwitcher = $container.find('.address-save-field');
                $saveSwitcher.removeAttr('disabled');
            }
        });

        $form.on('change', '.languages-switcher', function() {
            let languageIso = getLanguageIso();
            let clientId = getCustomerId();
            let $wrapper = jQuery('.addresses-wrapper');

            if (!clientId) {
                $wrapper.html('');
            } else {
                let destinationAddressId = jQuery('.destination-address-card-wrapper .address-selector').val();

                if (destinationAddressId) {
                    let data = {language_iso: languageIso, client_id: clientId, address_id: destinationAddressId};
                    let route = $wrapper.attr('data-addresses-route');
                    sendAjaxRequest($wrapper, route, data);
                } else {
                    let data = {language_iso: languageIso, client_id: clientId};
                    let route = $wrapper.attr('data-origin-address-route');
                    let $container = jQuery('.origin-address-card-wrapper');
                    sendAjaxRequest($container, route, data);
                }
            }
        });

        function sendAjaxRequest($container, route, data) {
            window.axios.post(route, data)
                .then(res => {
                    if (res && res.data && parseInt(res.data.result) === 1) {
                        $container.replaceWith(res.data.html);
                    }
                }).catch(err => {
                console.log(err);
            });
        }
    }());
});
